var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\" ng-if=\"!isSupervisorConfirmed\">\n<h4 class=\"modal-title\">{{'error.91322' | translate}} | {{model.data.bagId}}</h4>\n</div>\n<form class=\"form-validate\" ng-if=\"!isSupervisorConfirmed\">\n<confirm-supervisor event=\"'add-bag'\" button-text=\"'Remove'\" on-confirm=\"supervisorConfirmed\" on-error=\"supervisorCancelled\">\n</confirm-supervisor>\n<button ng-if=\"model.data.cancelSupervisorChallenge\" style=\"margin-top: -49px\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</form>";
var id1="bagRemoveConfirmation.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/common/ui/modal/templates/bagRemoveConfirmation.html
// module id = 2507
// module chunks = 1